import assign from 'lodash/assign';
import find from 'lodash/find';
import clone from 'lodash/clone';
import each from 'lodash/each';
import includes from 'lodash/includes';
import TemplateCache from './template-cache';
import { findInArray } from '../utils/stores';

const templateData = {};

templateData.setPhoto = function (pageData, templateData, slot, properties) {
  const currentSlot = findInArray(pageData.slots, 'id', slot.id);
  const meta = templateData.photo_slots[slot.id];

  slot = assign({ image: false, type: 'image' }, slot);

  if (currentSlot) {
    slot = assign(currentSlot, slot);
  } else {
    pageData.slots.push(slot);
  }

  slot.data = slot.data || TemplateCache.textSlotMetaToSlotData(meta);
  if (properties) {
    assign(slot.data, properties);
  }

  return pageData;
};

templateData.getPhoto = function (pageData, slotId) {
  return find(pageData.slots || [], 'id', slotId);
};

templateData.copyData = function (pageDataA, templateDataA, pageDataB, templateDataB) {
  const emptyImgSlots = clone(templateDataB.pso.filter((k) => k !== 'optional-bg'));
  const emptyTxtSlots = clone(templateDataB.tso);

  each(pageDataA.slots, (slot) => {
    if (slot.image && slot.type === 'image') {
      let nextSlotId, newSlot;

      // treat the optional-bg differently from the rest of the photo slots
      if (slot.id == 'optional-bg' && templateDataB.pso.filter((k) => k === 'optional-bg').length > 0) {
        nextSlotId = templateDataB.pso.find((k) => k === 'optional-bg');
      } else if (emptyImgSlots.length > 0) {
        nextSlotId = emptyImgSlots.shift();
      }

      if (!nextSlotId) return true; // Will tell lodash each to continue with the next iteration

      newSlot = assign({}, slot, { id: nextSlotId });
      pageDataB = templateData.setPhoto(pageDataB, templateDataB, newSlot);
    } else if (slot.type === 'text') {
      // resize slots to fit template?
      if (includes(templateDataA.tso, slot.id)) {
        // copy to equivalent slot
        if (includes(templateDataB.tso, slot.id)) {
          pageDataB.slots.push(slot);
        }
      } else {
        // copy as new user text slot
        pageDataB.slots.push(slot);
      }
    }
  });

  return pageDataB;
};

export default templateData;
